<template>
    <div>
        <button @click="showPanel">Show Menu</button>
        <slideout-panel></slideout-panel>
    </div>
</template>

<script>
export default {
    methods: {
        showPanel() {
            const panel = this.$showPanel({
                component: "SlideoutPanel",
                name: 'slideout-panel',
                openOn: 'top',
                props: {
                    //any data you want passed to your component
                }
            });

            panel.promise.then(result => {});
        },
        hidePanel() {
            this.panel.hide();
        }
    }
};
</script>

<style lang="scss" scoped></style>
